import { SubjectivityLibrarySearchRequestQuery } from '@lio/api-types';

export const SubjectivityLibraryKeys = {
  search: ['subjectivity-library'] as const,
  searchParams: (params: SubjectivityLibrarySearchRequestQuery) => [...SubjectivityLibraryKeys.search, params] as const,
};
